/* eslint-disable sort-keys */
// START GENAI@GHCOPILOT
import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';

export const shouldLog = document.cookie.indexOf('DEBUG=true') > -1 || false;

/* FOR DEVELOPMENT ONLY */
// for POC, hard-coded temporary keys
const applicationId = '047af3c6-42d8-419f-a20c-ae9bf18369ea';
const clientToken = 'pube6021b1619036a2b2d40022d8b4e51e9';
// `site` refers to the Datadog site parameter of your organization
// see https://docs.datadoghq.com/getting_started/site/
const site = 'us3.datadoghq.com';
const service = 'visa-ctp-poc';
const env = 'development';
// const allowedOrigins = [
//   'https://src-sdk-automation-qab-2.oce-np-sm-ddp-b-en.trusted.visa.com/',
//   'https://visa-ctp-poc.vercel.app/*',
//   'https://visa-ctp-poc.vercel.app/api/*',
// ];
const datadogRumConfig = {
  applicationId,
  clientToken,
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site,
  service,
  env,
  // Specify a version number to identify the deployed version of your application in Datadog
  version: '25.06.00-datadog.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,

  enablePrivacyForActionName: true,
  trackErrors: true,
  trackLongTasks: true,
  trackResources: true,
  trackUserInteractions: true

  // defaultPrivacyLevel: 'mask-user-input',
};

// CDN Sync load
export function loadDatadogRumCDN(correlationId: string, origin: string) {
  // create a script tag to load the Datadog RUM library
  const script = document.createElement('script');
  script.src = 'https://www.datadoghq-browser-agent.com/us3/v6/datadog-rum.js';
  // attach the script to the document head
  document.head.appendChild(script);
  // wait for the script to load
  script.onload = () => {
    shouldLog &&
      /* eslint-disable-next-line no-console */
      console.log(
        `>>>>>>>>>>>> Datadog RUM library loaded successfully for [ ${origin} ][ ${correlationId} ]`
      );

    // initialize the RUM with the configuration
    window.DD_RUM.init({
      ...datadogRumConfig, // CR: correlationId,
      correlationId // set the correlationId
    });

    // set user property for correlationId
    window.DD_RUM.setUserProperty('CR', correlationId); // set the correlationId
    // start session replay recording
    window.DD_RUM.startSessionReplayRecording();
  };

  window.addEventListener('unload', () => {
    window.DD_RUM.stopSessionReplayRecording();
  });
}

type CTPDDRumConfig = RumInitConfiguration & {
  CR: string;
  correlationId: string;
};

// NPM module based implementation of Datadog RUM
export function initDatadogRum(correlationId: string, origin: string) {
  shouldLog &&
    /* eslint-disable-next-line no-console */
    console.log(
      `>>>>>>>>>>>>>> Initializing Datadog RUM with correlationId: ${correlationId} for ${origin}`
    );

  // @ts-expect-error
  const ddConfig: CTPDDRumConfig = {
    ...datadogRumConfig,
    CR: correlationId,
    correlationId // set the correlationId
  };

  datadogRum.init(ddConfig as RumInitConfiguration);
  datadogRum.setUserProperty('CR', correlationId); // set the correlationId
}
// export function initDatadogRum(correlationId: string) {
//   console.log('>>>>>>>>>>>>>> Initializing Datadog RUM with correlationId:', correlationId);
//   datadogRum.init({
//     // allowedTracingOrigins: allowedOrigins,
//     applicationId: applicationId,
//     clientToken: clientToken,
//     // defaultPrivacyLevel: 'mask-user-input',
//     env: env,
//     sampleRate: 100,
//     service: service,
//     sessionReplaySampleRate: 100,
//     site: site,
//     trackErrors: true,
//     trackInteractions: true,
//     trackLongTasks: true,
//     trackResources: true,
//     trackUserInteractions: true,
//     trackViewsManually: true,
//     version: '1.0.0',
//     // data-resource compliance
//     // beforeSend(event, context) {
//     //     // Filter out events that are not relevant to the application
//     //     if (event.type === 'resource' && event.resource?.url) {
//     //         const url = new URL(event.resource.url);
//     //         if (!allowedOrigins.some(origin => url.origin.startsWith(origin))) {
//     //         return false; // Ignore this event
//     //         }
//     //     }
//     //     return true; // Keep the event

//     // },
//   });

//   datadogRum.setUserProperty('CR', correlationId);

// //   datadogRum.startSessionReplayRecording();
// }
// END GENAI@GHCOPILOT
